import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 px-4 bg-stone-50" data-id="element-119" data-mp="1o2vigsgkwt85">
      <div className="max-w-4xl mx-auto" data-id="element-120" data-mp="223ekniyd552e">
        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-white border border-stone-200 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden shadow-lg shadow-blue-950/5" data-id="element-121" data-mp="222d797tvk6hi">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1 bg-orange-500" data-id="element-122" data-mp="1j52dg2r0i59g" />
          <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-blue-950 text-orange-500 mb-8" data-id="element-123" data-mp="1edbxnh9b2pan">
            <ShieldCheck size={48} data-id="element-124" data-mp="qn7vzffogzma" />
          </div>
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6 text-blue-950" data-id="element-125" data-mp="lp6bqr6imu98">
            7-Day Guarantee
          </h2>
          <div className="space-y-6 text-lg text-slate-800 max-w-2xl mx-auto" data-id="element-126" data-mp="p0b9g1gzbkil">
            <p data-id="element-127" data-mp="tycqkguuh9rf">You have 7 days to review the material after purchase.</p>
            <p className="font-medium text-blue-950" data-id="element-128" data-mp="twi3avw3p5k6">
              If the material you receive is incorrect, defective, incomplete or materially
              different from what was advertised, contact our support team within the applicable
              period and the case will be reviewed according to the guarantee terms.
            </p>
            <p className="text-sm text-slate-500 mt-8" data-id="element-129" data-mp="ayyt3oxwpgw6">The product is delivered digitally.</p>
          </div>
        </motion.div>
      </div>
    </section>;
}